// extracted by mini-css-extract-plugin
export default {"outerWrapper":"SearchTab_outerWrapper__IZ-Yh","searchWrapper":"SearchTab_searchWrapper__oWLTF"};